import { format, startOfMonth, endOfMonth } from "date-fns";
import { de } from "date-fns/locale";
import { TimeEntry } from "@/types/time-entry";

export const getFilterDates = (selectedMonth: string) => {
  if (selectedMonth === "current") {
    // For current month, get the start and end of the current month
    const startDate = startOfMonth(new Date());
    const endDate = endOfMonth(new Date());
    
    return {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString()
    };
  }
  
  const [year, month] = selectedMonth.split("-").map(Number);
  const startDate = startOfMonth(new Date(year, month - 1));
  const endDate = endOfMonth(startDate);
  
  return {
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString()
  };
};

export const getFilterDisplayText = (selectedMonth: string) => {
  if (selectedMonth === "current") {
    return format(new Date(), "MMM yyyy", { locale: de });
  }
  
  const [year, month] = selectedMonth.split("-").map(Number);
  return format(new Date(year, month - 1), "MMM yyyy", { locale: de });
};

/**
 * Filters time entries by selected month value.
 * This is the SSOT for month filtering logic across the application.
 * @param timeEntries - Array of time entries to filter
 * @param selectedMonth - Month value ("current" or "YYYY-MM" format)
 * @returns Filtered array of time entries
 */
export const filterTimeEntriesByMonth = <T extends TimeEntry>(
  timeEntries: T[] | undefined,
  selectedMonth: string
): T[] => {
  if (!timeEntries) return [];
  if (selectedMonth === "current") return timeEntries;
  
  return timeEntries.filter(entry => {
    const entryDate = new Date(entry.start_time);
    const [year, month] = selectedMonth.split("-").map(Number);
    return entryDate.getFullYear() === year && entryDate.getMonth() === month - 1;
  });
};
